var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { Image } from '@inter-ikea-kompis/component-image';
import { Text } from '@inter-ikea-kompis/component-text';
import SummaryPageSecurityStyle from './SummaryPageSecurityStyle.js';
/**
 * The view for the Summary Page Security.
 */
class SummaryPageSecurity extends KompisElement {
    constructor() {
        super(...arguments);
        // The text for the title
        this.title = '';
        // The text for the description
        this.description = null;
        // The src string for the image
        this.imageSrc = null;
        // The alt text for the image
        this.imageAlt = null;
        // Highest heading on the Summary page security will be h3 as opposed to h2. Set to true if planner is e.g. used in an iframe with an h1 header outside of the planner.
        this.startHeadingsAtH3 = false;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        return html `
			<style>
				${SummaryPageSecurityStyle.getStyle({ theme: this.theme })}
			</style>
			<div>${this.getTitle()} ${this.getDescription()} ${this.getSecurityImage()}</div>
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-image', Image);
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
    /**
     * Renders the title.
     *
     * @returns The title.
     */
    getTitle() {
        if (!this.title) {
            return null;
        }
        const title = html `<kompis-text
			.theme="${this.theme}"
			.type="${ThemeFontStyleTypeEnum.headingMedium}"
			>${this.title}</kompis-text
		>`;
        if (this.startHeadingsAtH3) {
            return html `<h3 class="no-margin title">${title}</h3>`;
        }
        return html `<h2 class="no-margin title">${title}</h2>`;
    }
    /**
     * Renders the description.
     */
    getDescription() {
        if (!this.description) {
            return null;
        }
        return html ` <kompis-text
			class="description"
			.theme="${this.theme}"
			.type="${ThemeFontStyleTypeEnum.bodyLarge}"
			>${this.description}</kompis-text
		>`;
    }
    /**
     * Renders the security image.
     */
    getSecurityImage() {
        if (!this.imageSrc || !this.imageAlt) {
            return null;
        }
        return html `<kompis-image .alt="${this.imageAlt}" .src="${this.imageSrc}"></kompis-image>`;
    }
}
SummaryPageSecurity.eventTypes = [];
export default SummaryPageSecurity;
__decorate([
    property({ type: Object, required: true })
], SummaryPageSecurity.prototype, "theme", void 0);
__decorate([
    property({ type: String })
    // eslint-disable-next-line lit/no-native-attributes
], SummaryPageSecurity.prototype, "title", void 0);
__decorate([
    property({ type: String })
], SummaryPageSecurity.prototype, "description", void 0);
__decorate([
    property({ type: String })
], SummaryPageSecurity.prototype, "imageSrc", void 0);
__decorate([
    property({ type: String })
], SummaryPageSecurity.prototype, "imageAlt", void 0);
__decorate([
    property({ type: Boolean })
], SummaryPageSecurity.prototype, "startHeadingsAtH3", void 0);
//# sourceMappingURL=SummaryPageSecurity.js.map